import "./competitor-tracking.scss";
import ClipTray from "components/app/clip-tray";
import FiltersMenu from "components/app/project/filters-menu";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "types";
import api from "api";
import Heatmap from "components/app/project/heatmap";
import DailyInsights from "components/app/project/daily-insights";
import ComparisonPie from "components/app/project/comparison-pie";
import WorldMap from "components/app/project/world-map";

function CompetitorTracking() {
    const params: any = useParams();
    const state = useSelector((state: RootState) => state);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [dateFrom, setDateFrom] = useState(moment().subtract(1, "d").set("h", 0).set("m", 0).set("s", 0));
    const [dateTo, setDateTo] = useState(moment());
    const [streamIds, setStreamIds] = useState<number[]>([]);
    const [project, setProject] = useState<any>();
    const [competitors, setCompetitors] = useState<any[]>([]);
    const [clips, setClips] = useState<any[]>([]);
    const filtersRef = useRef<any>();

    useEffect(() => {
        if (state.project) {
            setProject(state.project);
            setStreamIds([7, 8, 9]);
            if (state.project.ProjectTypeId === 5) {
                setStreamIds([7, 8, 9]);
            } else {
                if (state.project.ProjectSubTypeId === 7) {
                    setStreamIds([7]);
                } else if (state.project.ProjectSubTypeId === 8) {
                    setStreamIds([8]);
                } else if (state.project.ProjectSubTypeId === 9) {
                    setStreamIds([10]);
                } else if (state.project.ProjectSubTypeId === 10) {
                    setStreamIds([9]);
                } else if (state.project.ProjectSubTypeId === 11) {
                    setStreamIds([11]);
                }
            }
        }
    }, [state.project]);

    const getClips = useCallback(
        async (binIds: number[]) => {
            const clips = await api.clip.getAllBins(binIds.join(), dateFrom, dateTo, streamIds.join());
            console.log("CLIPS FETCHED - ", clips);
            setClips(clips);
        },
        [dateFrom, dateTo, streamIds]
    );

    //note: when using binIds as a useState it was causing data issues, the array was pushing elements in a strange and inconsistent way and was sometimes overwriting values.
    //so I decided to pass the array directly to the getClips function. This seems to have solved the issues with the asynchronous data from the api call

    const getCompetitors = useCallback(
        async (projectId: number) => {
            const competitors = await api.competitor.getAll(projectId);
            console.log("get competitors - ", competitors);
            setCompetitors(competitors);
            const binIds_arr: number[] = [];
            competitors.forEach((item: any, index: number) => {
                binIds_arr.push(item.BinId);
            });
            binIds_arr.push(projectId);
            getClips(binIds_arr);
        },
        [getClips]
    );

    useEffect(() => {
        if (project) {
            setProject(project);
            getCompetitors(project.Id);
        }
    }, [getCompetitors, project]);

    if (streamIds.length) {
        return (
            <div className="content-classification">
                <div className="top">
                    <p className="project-name">{project?.Description}</p>
                    <p className="project-type">{project?.ProjectType}</p>
                    <span onClick={() => setFiltersOpen(true)} ref={filtersRef}>
                        Filter<i className={`fal ${filtersOpen ? "fa-times" : "fa-sliders-h"}`}></i>
                    </span>
                    <FiltersMenu
                        open={filtersOpen}
                        setOpen={setFiltersOpen}
                        dateFrom={dateFrom}
                        setDateFrom={setDateFrom}
                        dateTo={dateTo}
                        setDateTo={setDateTo}
                        streamIds={streamIds}
                        setStreamIds={setStreamIds}
                        projectTypeId={project?.ProjectTypeId}
                        showDatePicker={true}
                        buttonRef={filtersRef}
                    />
                </div>
                <div className="body">
                    <Heatmap projectId={params.projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds} />
                    <DailyInsights projectId={params.projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds} projectTypeId={project?.ProjectTypeId} section="competitor-tracking" competitors={competitors} clips={clips} />
                    <ComparisonPie competitors={competitors} clips={clips} />
                    {/* <WorldMap projectId={params.projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds}/> */}
                </div>
                <ClipTray />
            </div>
        );
    } else {
        return <h1>no stream Ids</h1>;
    }
}

export default CompetitorTracking;
